import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
// import * as $ from 'jquery';
import { TimeScale } from 'chart.js';
import Swal from 'sweetalert2'
declare var $: any;

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss']
})
export class CourseComponent implements OnInit {

  user_district: any = JSON.parse(localStorage.getItem('user_district'));
  userForm: any = JSON.parse(localStorage.getItem('login_user_details'));
  values: any = [];
  enrolled_values: any;

   MeetingOptions:any;
  participantsptions:any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
   users: any = JSON.parse(localStorage.getItem('login_user_details'));
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  isButtonDisabled :boolean=false;
  CM_id: any;
  editmeetingform !:FormGroup;
  da_district:string;
  district: any = this.ApiService.user_details.district;
  constituency: any = this.ApiService.constituency;
  courses: any;
  userDistrict: any = this.ApiService.user_details.district;
  userConstituency: any = this.ApiService.user_details.constituency;
  userId: any = this.ApiService.user_details.id;
  ob_data: any;
  mentor_data: any;
  CM_course_image: any;
  student: any = JSON.parse(localStorage.getItem('login_user_details'));
  permanent_token:any=JSON.parse(localStorage.getItem('permanent_token'));

  enrolledCourses: any[];

  constructor(private fb: FormBuilder, private ApiService: ApiServiceService, private router: Router,
    private spinnerService: NgxSpinnerService, public datepipe:DatePipe, private elementRef: ElementRef, private renderer: Renderer2) {
  
  }

  ngOnInit(): void {
    this.showSpinner();
    this.handleBackButtonForModal();

    // this.ApiService.getStudentCourseList(this.user_district,this.userForm.id).subscribe((data) => {
    //   console.log(data,"checking");
    //   this.values = data;
    //   console.log('this.values: ', this.values.length);
    // })
    //  this.ApiService.StudentEnrolledCourse(this.userForm.id,this.user_district).subscribe((data) => {
    //   console.log(data,"checking");
    //   this.enrolled_values = data;
    // })


    this.ApiService.getEnrolledCourses(this.student.id,this.permanent_token).subscribe(
      (response) => {
        if (response.status === 'success') {
          this.enrolledCourses = response.courses;
          console.log('Enrolled Courses:', this.enrolledCourses);
        } else {
          console.error('Error fetching enrolled courses:', response.message);
        }
      },
      (error) => {
        console.error('API error:', error);
      }
    );
  }

  
  public courseEnroll(course_id: any,item:any) {
    console.log(course_id, item, this.userForm.id);
    let user_id = this.userForm.id;
    let permanent_token=this.permanent_token;
        this.ApiService.StudentErollCourse(course_id,item.id,user_id,permanent_token).subscribe((d:any) => {
      console.log(d,"sdndsbjbdsskbskj"); 
              this.spinnerService.hide();
               setTimeout(function(){
                Swal.fire({
  title: "you are successfully Enrolled into the Course!",
  confirmButtonColor:'#015792',
  confirmButtonText: "Okay",
  icon: "success",
  iconColor: "#015792" // Set the icon color here

}).then((result) => {
  /* Read more about isConfirmed, isDenied below */
  if (result.isConfirmed) {
    window.location.reload();
  } 
});  
                },100)
                 
            //this.router.navigate(['superadmin/Meetings']);
             //angForm1.reset();
            },

            error => {
                console.log(error);
            });
    
  }

  public courseUnEnroll(course_id: any, item: any) {
    console.log(course_id, item, this.userForm.id);
    let user_id = this.userForm.id;
    this.ApiService.StudentUnErollCourse(course_id, item.id, user_id).subscribe(
        (d: any) => {
            console.log(d, "sdndsbjbdsskbskj");
            this.spinnerService.hide();
            setTimeout(function () {
                Swal.fire({
                    title: "Are you sure want to Unenroll the Course!",
                    confirmButtonColor:'#015792',
                    confirmButtonText: "Okay",
                    icon: "success",
                    iconColor: "#015792", // Set the icon color here
                    showCancelButton: true, // Show cancel button
                    cancelButtonColor:'#dc3545',
                    cancelButtonText: "Cancel" // Set cancel button text #dc3545
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                });
            }, 100);
        },
        error => {
            console.log(error);
        }
    );
}

 
    public showSpinner(): void {
    this.spinnerService.show();
    }
  
  showCourseDetails(data) {
    console.log(data, "sdsdnd");
  }


  CM_course_name: any;
  CM_district: any;
  CM_constituency: any;
  CM_organizer: any;
  CM_startDate: any;
  CM_endDate: any;
  CM_startTime: any;
  CM_endTime: any;
  CM_volunteer1: any;
  CM_volunteer2: any;
  CM_location: any;
  CM_status: any;
  CM_comments: any;
  CM_session_link: any;



  editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
    console.log(a,editbutton);
    //console.log(a.date)
    if (editbutton == 'edit') {
      this.editfield = true;
    } else {
      this.editfield = false;
    }
      this.CM_course_name=a.course_name;
          this.CM_district=a.district;
          this.CM_constituency=a.constituency;
    this.CM_startDate = a.start_date;
    this.CM_organizer = a.organizer;
          this.CM_endDate=a.end_date;
          this.CM_startTime=a.start_time;
          this.CM_endTime=a.end_time;
          this.CM_volunteer1=a.volunteer1;
    this.CM_volunteer2 = a.volunteer2;
    this.CM_location = a.location;
    this.CM_status = a.status;
    this.CM_comments = a.comments;
    this.CM_session_link = a.session_link;
    this.CM_course_image=a.image;

    this.CM_id = a.id;
    this.editmeetingform.get('comments').setValue(a.comments);
    this.editmeetingform.get('session_link').setValue(a.session_link);
    this.editmeetingform.get('course_name').setValue(a.course_name);
    this.editmeetingform.get('organizer').setValue(a.organizer);
      
          //this.editformInitialize(false);
      
   
    // this.editmeetingform.get('meeting_date').setValue(a.date);
    // this.editmeetingform.get('meeting_time').setValue(a.time);
          //this.editmeetingform.controls['meeting_date'].disable();
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_date);
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_time);

    }

        
          updatedata(updateform,id){
            console.log(updateform,id);  
            this.spinner = true;
            this.ApiService.updateDistrictOccurance(this.CM_id,updateform.value).pipe().subscribe(
              data => {
                console.log(data);
                this.spinnerService.hide();
                setTimeout(function () {
                  Swal.fire({
                    title: "Course District Occurrence detail has been updated!",
                    confirmButtonColor:'#015792',
                    confirmButtonText: "Okay",
                    icon: "success",
                    iconColor: "#015792" // Set the icon color here
                  }).then(() => {
                    window.location.reload();
                  });
                }, 100);
                
                },
              
              error => {
                console.log(error);
              });
          }

//reset form values in createform
  Formreset(){
    this.createmeetingform.reset();
    this.hidden=true;
    this.MeetingOptions='';
    //this.participantsptions='';
}

unenroll(id: number) {
  const student_id = this.student.id;

  // Show confirmation dialog
  Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, unenroll it!',
    cancelButtonText: 'Cancel'
  }).then((result) => {
    if (result.isConfirmed) {
      // Create the unenrollment data object
      const unenrollmentData = {
        id: id,
        student_id: student_id
      };

      // Show spinner
      this.spinnerService.show();

      // Call the service method to send the unenrollment data to the backend
      this.ApiService.unenrollCourse(unenrollmentData).subscribe(
        (response: any) => {
          console.log('Unenrollment response', response);
          this.spinnerService.hide();

          if (response.status === 'success') {
            Swal.fire({
              icon: 'success',
              title: 'Unenrollment Successful',
              text: response.message,
              confirmButtonText: 'OK'
            }).then(() => {
              // Optionally, remove the course from the enrolledCourses array
              this.enrolledCourses = this.enrolledCourses.filter(course => course.id !== id);
              // Reload the page or refresh the component data
              location.reload();  // Reload the entire page
              // or
              // this.loadEnrolledCourses();  // Reload just the course data (if you have such a method)
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Unenrollment Failed',
              text: response.message,
              confirmButtonText: 'OK'
            });
          }
        },
        error => {
          console.error('Unenrollment failed', error);
          this.spinnerService.hide();

          Swal.fire({
            icon: 'error',
            title: 'Unenrollment Failed',
            text: 'There was an issue with your unenrollment. Please try again.',
            confirmButtonText: 'OK'
          });
        }
      );
    }
  });
}
studentEnroll: any = null; // Variable to store the selected student's details
modalTitle: string = '';

showEnroll(course: any,action: string) {
  console.log(course);
  if (course) {
    // Assuming you want to show details of the first student in the course

    this.studentEnroll = {
      course_name: course.course_name,
      course_date: course.course_date,
      course_time: course.course_time,
      course_des: course.course_des,
      online_meet_link: course.online_meet_link,
      typeofcourse: course.typeofcourse,
    };

    // Set modal title
    this.modalTitle = action === 'edit' ? 'Edit Student’s Detail' : 'Student’s Detail';

    // Use jQuery to show the modal
    $('#myModal').modal('show');
  }
}
  
handleBackButtonForModal() {
  // Push initial state to history
  history.pushState(null, '', window.location.href);

  window.onpopstate = () => {
    const modal = document.querySelector('.modal.show') as HTMLElement;
    if (modal) {
      // Find the close button inside the modal and trigger a click event on it
      const closeButton = modal.querySelector('.close') as HTMLElement;
      if (closeButton) {
        closeButton.click();
      }

      // Prevent default back navigation
      history.pushState(null, '', window.location.href);
    } else {
      // Allow back navigation as usual if modal is not open
      this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
    }
  };
}
ngOnDestroy(): void {
  // Cleanup event listener to avoid memory leaks
  window.onpopstate = null;
}
}
